"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addRootSpousesPositions = void 0;
var getNodeBottomY_1 = require("./getNodeBottomY");
var getNodeRightX_1 = require("./getNodeRightX");
var getFromMap_1 = require("./getFromMap");
var addRootSpousesPositions = function (root, settings, map) {
    if (root[settings.nextAfterAccessor])
        getFromMap_1.getFromMap(root[settings.nextAfterAccessor], map).forEach(function (currentNode, nextAfterIndex, nextAfters) {
            var previousNode = nextAfters[nextAfterIndex - 1] || root;
            if (settings.orientation === "vertical") {
                currentNode.x = getNodeRightX_1.getNodeRightX(previousNode);
                // align vertically
                currentNode.y = root.y + root.height / 2 - currentNode.height / 2;
                var bottomEdgeY = currentNode.y + currentNode.height + currentNode.marginBottom;
                if (currentNode.y < root.groupTopY)
                    root.groupTopY = currentNode.y;
                if (bottomEdgeY > root.groupBottomY)
                    root.groupBottomY = bottomEdgeY;
            }
            else {
                currentNode.y = getNodeBottomY_1.getNodeBottomY(previousNode);
                // align horizontally
                currentNode.x = root.x + root.width / 2 - currentNode.width / 2;
                //TODO: this function is the same in addRootSiblingsPositions (and above)
                var currentRightEdgeX = currentNode.x + currentNode.width + currentNode.marginRight;
                if (currentNode.x < root.groupLeftX)
                    root.groupLeftX = currentNode.x;
                if (currentRightEdgeX > root.groupRightX)
                    root.groupRightX = currentRightEdgeX;
            }
        });
};
exports.addRootSpousesPositions = addRootSpousesPositions;
//# sourceMappingURL=addRootSpousesPositions.js.map